function _flattenSmarttags(stags) {
    var flatten = [];
    stags.forEach(function (stag) {
        (stag.values || []).forEach(function (v) {
            flatten.push("".concat(stag.key, ":").concat(v.key));
        });
    });
    return flatten;
}
var isEqual = function (a, b) {
    if (a === void 0) { a = []; }
    if (b === void 0) { b = []; }
    if (!Array.isArray(a) || !Array.isArray(b)) {
        return false;
    }
    if (a.length !== b.length) {
        return false;
    }
    var A = _flattenSmarttags(a).slice().sort().toString();
    var B = _flattenSmarttags(b).slice().sort().toString();
    return A === B;
};
export default isEqual;
